import React, {Fragment, useState, useEffect} from 'react';
import {Section, Accordion, Popup, Explanation_text, Select, Text, Info} from '../../../components';
import {Form, Field} from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';
import arrayMutators from 'final-form-arrays';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';
import WebIcon from '@material-ui/icons/Web';
import IconButton from '@material-ui/core/IconButton';
import CustomFieldIcon from '@material-ui/icons/List';
import MergeTypeIcon from '@material-ui/icons/MergeType';
import {connect} from 'react-redux';

function Custom_fields(props){
  const max_fields=20;
  const [custom_fields_merge_popup, setCustomFieldsMergePopup]=useState();
  const [custom_field_delete_popup, setCustomFieldDeletePopup]=useState();
  const [custom_field_create_update_popup, setCustomFieldCreateUpdatePopup]=useState();

  return(<Fragment>
    <Section_element {...props} type="COMPANY" max_fields={20} setCustomFieldsMergePopup={setCustomFieldsMergePopup} setCustomFieldCreateUpdatePopup={setCustomFieldCreateUpdatePopup} setCustomFieldDeletePopup={setCustomFieldDeletePopup}/>
    <Section_element {...props} type="CONTACT" max_fields={10} setCustomFieldsMergePopup={setCustomFieldsMergePopup} setCustomFieldCreateUpdatePopup={setCustomFieldCreateUpdatePopup} setCustomFieldDeletePopup={setCustomFieldDeletePopup}/>
    <Section_element {...props} type="DEAL" max_fields={10} setCustomFieldsMergePopup={setCustomFieldsMergePopup} setCustomFieldCreateUpdatePopup={setCustomFieldCreateUpdatePopup} setCustomFieldDeletePopup={setCustomFieldDeletePopup}/>
    <Section_element {...props} type="USER" max_fields={5} setCustomFieldsMergePopup={setCustomFieldsMergePopup} setCustomFieldCreateUpdatePopup={setCustomFieldCreateUpdatePopup} setCustomFieldDeletePopup={setCustomFieldDeletePopup}/>
    {(custom_field_create_update_popup==undefined)?null:<Custom_field_create_update_popup {...props} workspace_field_data={custom_field_create_update_popup} handleClose={()=>{setCustomFieldCreateUpdatePopup(undefined);}}/>}
    {(custom_field_delete_popup==undefined)?null:<Custom_field_delete_popup {...props} workspace_field_data={custom_field_delete_popup} handleClose={()=>{setCustomFieldDeletePopup(undefined);}}/>}
    {(custom_fields_merge_popup==undefined)?null:<Custom_fields_merge_popup {...props} entity_type={custom_fields_merge_popup} handleClose={()=>{setCustomFieldsMergePopup(undefined)}}/>}
    </Fragment>
  )
}


function Section_element(props){

  if(props.types!=undefined && props.types.includes(props.type)){
    let spec_fields=[];
    if(props.workspace!=undefined && props.workspace.workspace_fields!=undefined){
      for(let wf of props.workspace.workspace_fields){
        if(wf.entity_type==props.type){spec_fields.push(wf);}
      }
    }
    return(
      <Section maxWidth='600px' icon={<CustomFieldIcon/>} title={<span><span>{"Custom "+props.type.toLowerCase()+" fields ("+spec_fields.length+'/'+props.max_fields+')'}</span><span><Info name='custom_fields'/></span></span>} action={
        <div>
        {(spec_fields.length<2)?null:<div style={{position:'absolute', top:'0px', right:'20px'}}><Tooltip title='Merge'><MergeTypeIcon style={{fontSize:'20px', cursor:'pointer'}} onClick={()=>{props.setCustomFieldsMergePopup(props.type);}}/></Tooltip></div>}
        <Tooltip title={(spec_fields.length<props.max_fields)?'Add a new custom field':'Maximum amount reached'}><AddIcon color='primary' onClick={()=>{if(spec_fields.length<props.max_fields){props.setCustomFieldCreateUpdatePopup(props.type);}}} style={{fontSize:'20px', cursor:'pointer'}}/></Tooltip>
        </div>
      }>
        <div style={{position:'relative'}}>{<Custom_fields_list {...props} type={props.type} onDelete={props.setCustomFieldDeletePopup} onUpdate={props.setCustomFieldCreateUpdatePopup}/>}</div>
      </Section>
    )
  }else{return (<div/>)}
}



function Custom_fields_merge_popup(props){
  function onSubmit(params){props.mergeWorkspaceFields(params.from_id, params.to_id)}
  let company_workspace_fields=[]; if(props.workspace!=undefined && props.workspace.workspace_fields!=undefined){for(let wf of props.workspace.workspace_fields){if(wf.entity_type==props.entity_type){company_workspace_fields.push(wf);}}}
  return(
    <Form
      onSubmit={onSubmit}
    >
      {form_props => (
        <form onSubmit={form_props.handleSubmit}>
      <Popup always_open accept_button={'Merge'} accept_button_click={()=>{form_props.form.submit(); form_props.form.reset(); props.handleClose();}} title='merge_custom_fields_popup_title' handleClose={props.handleClose} content={
        <div style={{width:'95vw', maxWidth:'600px', height:'300px'}}>
          <div style={{width:'calc(100% - 40px)', marginLeft:'20px', textAlign:'center', marginTop:'20px'}}><Explanation_text variant='caption' color='error' text='merge_custom_fields_popup_warning_text'/></div>
          <Grid container style={{marginTop:'40px', width:'calc(100% - 40px)', marginLeft:'20px'}}><Grid item xs={6}><Select title='From' name='from' select_data={company_workspace_fields}/></Grid><Grid item xs={6}><Field name='from'>{(f)=><Select title='To' name='to' select_data={remove_option(f.input.value, company_workspace_fields)}/>}</Field></Grid></Grid>
        </div>
      }/>
      </form>
    )}
    </Form>
   )
}


function Custom_field_delete_popup(props){

  return(
    <Popup always_open accept_button={'Delete'} accept_button_click={()=>{props.deleteWorkspaceField(props.workspace_field_data.id); props.handleClose();}} title={"Delete "+props.workspace_field_data.entity_type.toLowerCase()+" field"} handleClose={props.handleClose} content={
        <div style={{width:'95vw', maxWidth:'600px', height:'300px'}}>
          <div style={{width:'calc(100% - 40px)', marginLeft:'20px', textAlign:'center', marginTop:'40px'}}><Typography >{'Are you sure you wish to delete the field '}<b>{'"'+props.workspace_field_data.name+'"'}</b>{' ?'}</Typography></div>
          <div style={{width:'calc(100% - 40px)', marginLeft:'20px', textAlign:'center', marginTop:'40px'}}><Explanation_text  color='error' text='delete_custom_fields_popup_warning_text'/></div>
        </div>
      }/>
   )
}

function Custom_field_create_update_popup(props){

    function onSubmit(params){
      if(props.workspace_field_data=='COMPANY' || props.workspace_field_data=='CONTACT' || props.workspace_field_data=='DEAL' || props.workspace_field_data=='USER'){
        params.entity_type=props.workspace_field_data;
        props.createWorkspaceField(params);
      }else{
        props.updateWorkspaceField(params.id, params);
      }
    }

    let documents_select=[]; if(props.documents!=undefined){for(let key in props.documents){documents_select.push(props.documents[key]);}}
  let entity_type=props.workspace_field_data; if(entity_type.entity_type!=undefined){entity_type=entity_type.entity_type;}
  console.log(props, props.workspace_field_data, entity_type, 'ENTITY TYPE');
  
  return(
    <Form
      onSubmit={onSubmit}
      initialValues={(props.workspace_field_data=='COMPANY' || props.workspace_field_data=='CONTACT' || props.workspace_field_data=='DEAL' || props.workspace_field_data=='USER')?{availability:0}:props.workspace_field_data}
      mutators={{
        ...arrayMutators
      }}
    >
      {form_props => (
        <form onSubmit={form_props.handleSubmit}>
        <Popup handleClose={props.handleClose} always_open accept_button='Save' accept_button_click={()=>{form_props.form.submit(); form_props.form.reset(); props.handleClose()}} force_title title={<Field name='workspace_fields'>{(f)=>{return(<div>Custom fields</div>)}}</Field>} content={
          <div style={{width:'95vw', maxWidth:'600px', minHeight:'500px'}}>
          <Grid container style={{marginTop:'20px'}}>
            <Grid item xs={6}><Text required  title='Name' name='name'/></Grid>
            <Grid item xs={6}></Grid>
            <Grid item xs={6} style={{marginTop:'5px'}}><Select required  title='Data type' name='data_type' select_data={[{id:0, name:'Text'}, {id:2, name:'Numeric'}, {id:6, name:'Multi text'}, {id:1, name:'Select/Radio'}, {id:3, name:'Checkboxes'}, {id:4, name:'Text with default options'}, {id:5, name:'Numeric with default options'}]}/></Grid>
            {(entity_type=='CONTACT' || entity_type=='DEAL' || entity_type=='USER')?null:<Grid item xs={6} style={{marginTop:'5px'}}><Select required  title='Availability' name='availability' select_data={[{id:0, name:'Normal'}, {id:1, name:'Mandatory'}, {id:2, name:'Restrict Edit'}, {id:3, name:'Restrict View'}]}/></Grid>}
            <Grid item xs={12} style={{marginTop:'5px'}}><Text  title='Description' name='description' multiline rows={3}/></Grid>
            <Field name='data_type'>{(f)=>
              (f.input.value==1 || f.input.value==3 || f.input.value==4 || f.input.value==5)?
              <Fragment>
              <hr style={{width:'100%'}}/>
              <FieldArray name='workspace_field_options'>
              {({ fields }) =>
              <div style={{width:'100%', marginBottom:'20px'}}>
              <div style={{width:'100%', position:'relative'}}><Typography color='primary' style={{marginLeft:'15px', marginBottom:'10px', marginTop:'10px'}}>Multiple choice options:</Typography><IconButton onClick={() => {fields.push({}, undefined)}} style={{right:'10px', top:'-10px', position:'absolute'}}><AddIcon/></IconButton></div>
                {fields.map(function(name, index){
                  return(<Grid container style={{width:'100%'}}>
                    <Grid item xs={5}><Text required  title='Name' name={`${name}.name`}/></Grid>
                    <Grid item xs={5}><div style={{marginTop:'5px'}}><Select  title='Document' name={`${name}.document_id`} select_data={documents_select}/></div></Grid>
                    <Grid item xs={2} style={{position:'relative'}}><DeleteIcon color="disabled" style={{cursor:'pointer', position:'absolute', right:'22px', bottom:'5px'}} onClick={()=>{fields.remove(index)}}/></Grid>
                    <Grid item xs={5}/>
                    </Grid>)
                })}
              </div>
            }</FieldArray>
              </Fragment>
              :<div style={{height:'20px'}}/>
            }</Field>
          </Grid>
          </div>
        }/>
        </form>
      )}
    </Form>
  )
}




//(wf.availability==0)?<span style={{color:'blue'}}>Normal</span>:(wf.availability==1)?<span style={{color:'green'}}>Mandatory</span>:(wf.availability==2)?<span style={{color:'orange'}}>Restrict Edit</span>:<span style={{color:'red'}}>Restrict View</span>
//(wf.availability==0)?"Normal":(wf.availability==1)?"Mandatory":(wf.availability==2)?"Restrict Edit":"Restrict View"


function Custom_fields_list(props){
  const[currently_open, setCurrentlyOpen]=useState(false);

  useEffect(()=>{
    if(props.documents_index!=true){props.indexDocuments();}
  },[]);

  if(props.workspace!=undefined && props.workspace.workspace_fields!=undefined){
    return(<Fragment>{
    props.workspace.workspace_fields.map(function(wf){
      if(wf.entity_type==props.type){
        let open=(currently_open==wf.id)?true:false;
        console.log(open, 'OPEN');
        return(<Accordion open={open} onChange={()=>{setCurrentlyOpen((wf.id==currently_open)?undefined:wf.id);}} size='small' content={[{
          title:<Typography variant='caption' color='primary' style={{position:'relative', width:'calc(100% - 30px)'}}>
                <Grid container>
                  <Grid item xs={8}>{wf.name}</Grid>
                  {(open==false)?<Grid item xs={4}>{(wf.availability==0)?<span></span>:(wf.availability==1)?<span style={{color:'green'}}>Mandatory</span>:(wf.availability==2)?<span style={{color:'orange'}}>Restrict Edit</span>:<span style={{color:'red'}}>Restrict View</span>}</Grid>:null}
                </Grid>
                <EditIcon style={{position:'absolute', right:'-20px', top:'2px', fontSize:'15px', cursor:'pointer'}} color='primary' onClick={()=>{props.onUpdate(wf);}}/>
                <DeleteIcon style={{position:'absolute', right:'-35px', top:'2px', fontSize:'15px', cursor:'pointer'}} color='error' onClick={()=>{props.onDelete(wf);}}/>
                </Typography>,
          content:<div style={{width:'100%'}}>
            <div style={{marginTop:'-10px', width:'calc(100% - 20px)', marginLeft:'20px'}}>
            <div><Typography variant='caption'><b>{'Data type: '}</b>{(wf.data_type==0)?'Text':(wf.data_type==1)?'Select/Radio':(wf.data_type==2)?'Numeric':(wf.data_type==3)?'Checkboxes':(wf.data_type==4)?'Text (options)':(wf.data_type==5)?'Numeric (options)':'Multi text'}</Typography></div>
            <div><Typography variant='caption'><b>{'Availability: '}</b>{(wf.availability==0)?<span>Normal</span>:(wf.availability==1)?<span style={{color:'green'}}>Mandatory</span>:(wf.availability==2)?<span style={{color:'orange'}}>Restrict Edit</span>:<span style={{color:'red'}}>Restrict View</span>}</Typography></div>
            {(wf.description==undefined)?null:<div><Typography variant='caption'><b>{'Description: '}</b>{(wf.description==undefined)?'':wf.description}</Typography></div>}
            </div>
            {(wf.workspace_field_options==undefined || wf.workspace_field_options.length==0)?undefined:
              <Fragment>
              <hr style={{width:'calc(100% -40px)', marginLeft:'20px'}}/>
              <Grid container style={{width:'calc(100% - 20px)', marginLeft:'20px'}}>
                <Grid item xs={4}><Typography variant='caption' color='primary'><b>Option</b></Typography></Grid>
              </Grid>

              {wf.workspace_field_options.map(function(wfo){
                return(
                  <Grid container style={{width:'calc(100% - 20px)', marginLeft:'20px', marginTop:'3px', marginBottom:'3px'}}>
                    <Grid item xs={4}><Typography variant='caption'>{wfo.name}</Typography></Grid>
                    <Grid item xs={4}><Tooltip label={(wfo.document_id!=undefined && props.documents!=undefined && props.documents[wfo.document_id]!=undefined)?props.documents[wfo.document_id].notes:null}><Typography variant='caption' color={(wfo.deleted_at==null)?undefined:'error'}>{(wfo.document_id!=undefined && props.documents!=undefined && props.documents[wfo.document_id]!=undefined)?props.documents[wfo.document_id].name:null}</Typography></Tooltip></Grid>
                    <Grid item xs={2}>{(wfo.document_id==null)?null:<WebIcon style={{cursor:'pointer'}} color={(wfo.deleted_at==null)?undefined:'error'} onClick={()=>{setDocumentPreviewPopup((wfo.document_id!=undefined && props.documents!=undefined && props.documents[wfo.document_id]!=undefined)?props.documents[wfo.document_id]:null);}}/>}</Grid>
                    <Grid item xs={2}><Typography variant='caption' color={(wfo.deleted_at==null)?'primary':'error'}>{(wfo.deleted_at==undefined)?undefined:wfo.deleted_at.split('T')[0]}</Typography></Grid>
                  </Grid>
                )})}
              </Fragment>
            }
            <div style={{marginTop:'30px'}}/>
            </div>
        }]}/>)
      }
    })}
    </Fragment>)
  }
}
function remove_option(id, data){ let new_data=[]; for(let d of data){if(d.id!=id){new_data.push(d);}} return new_data;}
//<Grid item xs={4}><Typography variant='caption' color='primary'><b>Document</b></Typography></Grid>
//<Grid item xs={4}><Typography variant='caption' color='primary'><b>Deleted</b></Typography></Grid>


export default connect(ss, dd)(Custom_fields);

function ss(state){
  return{
    documents:state.sales_coach.documents,
    documents_index:state.sales_coach.documents_index,
  }
}

function dd(dispatch){
    return{
      indexDocuments:()=>{dispatch({type:'REQUEST_INDEX_DOCUMENTS'});},
      createWorkspaceField:(params)=>{dispatch({type:'REQUEST_CREATE_WORKSPACE_FIELD', payload:params});},
      updateWorkspaceField:(id, params)=>{dispatch({type:'REQUEST_UPDATE_WORKSPACE_FIELD', id:id, payload:params});},
      deleteWorkspaceField:(id)=>{dispatch({type:'REQUEST_DELETE_WORKSPACE_FIELD', id:id});},
      mergeWorkspaceFields:(from, to)=>{dispatch({type:'REQUEST_MERGE_WORKSPACE_FIELDS', from:from, to:to});},
    }
}
